import React from 'react';

const EmergencyContactTab = ({ formData, handleNestedInputChange, FormField }) => {
  return (
    <div className="bg-white/95 backdrop-blur-xl border border-white/20 shadow-2xl shadow-slate-200/50 rounded-3xl p-8 overflow-hidden relative">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-50/40 via-transparent to-rose-50/40 pointer-events-none" />

      {/* Header */}
      <div className="relative flex items-center gap-4 mb-8">
        <div className="w-14 h-14 bg-gradient-to-br from-red-500 to-rose-600 rounded-2xl flex items-center justify-center shadow-lg shadow-red-500/30">
          <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
        </div>
        <div>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">Emergency Contact</h2>
          <p className="text-slate-500 mt-1">Primary contact person in case of emergency</p>
        </div>
      </div>

      <div className="relative space-y-6">
        <div className="grid md:grid-cols-2 gap-6">
          <FormField
            id="emergency_name"
            label="Contact Name"
            value={formData.emergency_contact?.name || ''}
            onChange={(e) => handleNestedInputChange('emergency_contact', 'name', e.target.value)}
            placeholder="Full name of emergency contact"
          />

          <FormField
            id="emergency_relationship"
            label="Relationship"
            value={formData.emergency_contact?.relationship || ''}
            onChange={(e) => handleNestedInputChange('emergency_contact', 'relationship', e.target.value)}
            placeholder="e.g., Spouse, Parent, Sibling"
          />

          <FormField
            id="emergency_phone"
            label="Phone Number"
            value={formData.emergency_contact?.phone || ''}
            onChange={(e) => handleNestedInputChange('emergency_contact', 'phone', e.target.value)}
            placeholder="+1 (555) 123-4567"
          />

          <div className="space-y-2">
            <label htmlFor="emergency_email" className="text-sm font-semibold text-slate-700">Email Address</label>
            <input
              id="emergency_email"
              type="email"
              value={formData.emergency_contact?.email || ''}
              onChange={(e) => handleNestedInputChange('emergency_contact', 'email', e.target.value)}
              className="w-full h-12 px-4 bg-white border border-slate-200 rounded-xl
                focus:border-violet-400 focus:ring-4 focus:ring-violet-100 focus:shadow-lg focus:shadow-violet-100/50
                hover:border-slate-300 hover:shadow-sm
                transition-all duration-200 ease-out placeholder:text-slate-400"
              placeholder="emergency@contact.com"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactTab;